import React, { Component } from 'react';
import * as Config from './../../config/Config';
import * as Common from './../../helpers/Common';
import * as User from './../../helpers/User';
import AssessementStatus  from './AssessementStatus';
import AssessementMail  from './AssessementMail';
const $=window.$;

//const $=window.$;
// const win=window;

class AssessementComp extends Component {
	constructor(props) {
		super(props);

        this.state={
				comp : <AssessementStatus sentData={this.getData.bind(this)}/>
				};

		

	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			comp:<AssessementStatus sentData={this.getData.bind(this)}/>
		})
    }

    getData(mail,evals,comp){
    	this.setState({
    		comp : <AssessementMail mail={mail} evals={evals} comp={comp} />
    	})
    }


	componentDidMount() {

	}

	render() {

		return (
			 <section id="contentsection" className="contentarea">
		          <div className="inner-title-bg journey-tit-bg">
		            <h1> <span> <img src={process.env.PUBLIC_URL+'/images/img-myperformance.jpg'} align="absmiddle" alt="" border="0" /> </span> My Performance<br />
		              <span className="subtitle">Assessment Status.</span></h1>
		          </div>

					<div className="myperformance">
						<section id="semana-scroll-inner" className="scroll">
						<section className="viewport">
						<section className="overview">
						<div className="inner-content">
							{this.state.comp}
						</div>
						</section>
						</section>
						</section>
					</div>
				</section>
			);

	}
}

export default AssessementComp;



// WEBPACK FOOTER //
// ./src/learning_records/my_performance/AssessementComp.js